<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
            <b-form  @submit.prevent="handleSubmit(submit)" @reset.prevent="reset" >
              <b-card no-body>
                <iq-card>
                  <template v-slot:headerTitle>
                      <h4 class="card-title">{{ $t('social_service.pat_social') }}</h4>
                  </template>
                  <!-- <template v-slot:headerAction>
                    <b-button variant="primary" @click="pdfExport" class="mr-2">
                      {{  $t('globalTrans.export_pdf') }}
                    </b-button>
                  </template> -->
                  <template v-slot:body>
                    <b-table-simple bordered>
                      <b-tbody>
                        <b-tr>
                          <b-td class="w-25">
                            {{$t('social_service.personal_home')}}
                          </b-td>
                            <b-td style="padding-left:20px">
                              <ValidationProvider name="Personal" vid="personal" rules="required">
                                    <b-form-group v-slot="{ personal }">
                                      <b-form-radio v-model="socio_ecio.personal" :aria-describedby="personal" name="personal" value="1">{{$t('social_service.yes')}}</b-form-radio>
                                      <b-form-radio v-model="socio_ecio.personal" :aria-describedby="personal" name="personal" value="2">{{$t('social_service.no')}}</b-form-radio>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-td>
                            <b-td style="padding-left:20px">
                              <ValidationProvider name="Personal Comment (Bn)" vid="personal_comment_bn" rules="required">
                                  <b-form-group class="" label-for="personal_comment_bn" slot-scope="{ valid, errors }">
                                    {{$t('social_service.coment_bn')}}
                                    <b-form-textarea id="personal_comment_bn" v-model="socio_ecio.personal_comment_bn"
                                    :class="{icons_long: !wrapIcons}"
                                    rows="3"
                                    max-rows="3"
                                    :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                    <div class="invalid-feedback">
                                      {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                              <ValidationProvider name="Personal Comment (En)" vid="personal_comment" rules="required">
                                  <b-form-group class="" label-for="personal_comment" slot-scope="{ valid, errors }">
                                    {{$t('social_service.coment_en')}}
                                    <b-form-textarea id="personal_comment" v-model="socio_ecio.personal_comment"
                                    rows="3"
                                    max-rows="3"
                                    :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                    <div class="invalid-feedback">
                                      {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td class="w-25">
                            {{$t('social_service.affec_geo_posi')}}
                          </b-td>
                          <b-td style="padding-left:20px">
                            <ValidationProvider name="Affected" vid="affected" rules="required">
                                  <b-form-group v-slot="{ affected }">
                                    <b-form-radio v-model="socio_ecio.affected" :aria-describedby="affected" name="affected" value="1">{{$t('social_service.yes')}}</b-form-radio>
                                    <b-form-radio v-model="socio_ecio.affected" :aria-describedby="affected" name="affected" value="2">{{$t('social_service.no')}}</b-form-radio>
                                  </b-form-group>
                              </ValidationProvider>
                          </b-td>
                          <b-td style="padding-left:20px">
                            <ValidationProvider name="Affected Comment (Bn)" vid="affected_comment_bn" rules="required">
                                <b-form-group class="" label-for="affected_comment_bn" slot-scope="{ valid, errors }">
                                  {{$t('social_service.coment_bn')}}
                                  <b-form-textarea id="affected_comment_bn" v-model="socio_ecio.affected_comment_bn"
                                  :class="{icons_long: !wrapIcons}"
                                  rows="3"
                                  max-rows="3"
                                  :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                            </ValidationProvider>
                            <ValidationProvider name="Affected Comment (En)" vid="affected_comment" rules="required">
                                <b-form-group class="" label-for="affected_comment" slot-scope="{ valid, errors }">
                                  {{$t('social_service.coment_en')}}
                                  <b-form-textarea id="affected_comment" v-model="socio_ecio.affected_comment"
                                  rows="3"
                                  max-rows="3"
                                  :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                            </ValidationProvider>
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td class="w-25">
                            {{$t('social_service.jakat_eli')}}
                          </b-td>
                          <b-td style="padding-left:20px">
                            <ValidationProvider name="Jakat" vid="jakat" rules="required">
                                  <b-form-group v-slot="{ jakat }">
                                    <b-form-radio v-model="socio_ecio.jakat" :aria-describedby="jakat" name="jakat" value="1">{{$t('social_service.yes')}}</b-form-radio>
                                    <b-form-radio v-model="socio_ecio.jakat" :aria-describedby="jakat" name="jakat" value="2">{{$t('social_service.no')}}</b-form-radio>
                                  </b-form-group>
                              </ValidationProvider>
                          </b-td>
                          <b-td style="padding-left:20px">
                            <ValidationProvider name="Jakat Comment (Bn)" vid="jakat_comment_bn" rules="required">
                                <b-form-group class="" label-for="jakat_comment_bn" slot-scope="{ valid, errors }">
                                  {{$t('social_service.coment_bn')}}
                                  <b-form-textarea id="jakat_comment_bn" v-model="socio_ecio.regular_comment_bn"
                                  :class="{icons_long: !wrapIcons}"
                                  rows="3"
                                  max-rows="3"
                                  :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                            </ValidationProvider>
                            <ValidationProvider name="Jakat Comment (En)" vid="jakat_comment" rules="required">
                                <b-form-group class="" label-for="jakat_comment" slot-scope="{ valid, errors }">
                                  {{$t('social_service.coment_en')}}
                                  <b-form-textarea id="jakat_comment" v-model="socio_ecio.jakat_comment"
                                  rows="3"
                                  max-rows="3"
                                  :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                            </ValidationProvider>
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td class="w-25">
                            {{$t('social_service.vill_cen_life')}}
                          </b-td>
                          <b-td style="padding-left:20px">
                            <ValidationProvider name="Village Centric" vid="village_centric" rules="required">
                                  <b-form-group v-slot="{ village_centric }">
                                    <b-form-radio v-model="socio_ecio.village_centric" :aria-describedby="village_centric" name="village_centric" value="1">{{$t('social_service.yes')}}</b-form-radio>
                                    <b-form-radio v-model="socio_ecio.village_centric" :aria-describedby="village_centric" name="village_centric" value="2">{{$t('social_service.no')}}</b-form-radio>
                                  </b-form-group>
                              </ValidationProvider>
                          </b-td>
                          <b-td style="padding-left:20px">
                            <ValidationProvider name="Village Centric Comment (Bn)" vid="village_centric_comment_bn" rules="required">
                                <b-form-group class="" label-for="village_centric_comment_bn" slot-scope="{ valid, errors }">
                                  {{$t('social_service.coment_bn')}}
                                  <b-form-textarea id="village_centric_comment_bn" v-model="socio_ecio.regular_comment_bn"
                                  :class="{icons_long: !wrapIcons}"
                                  rows="3"
                                  max-rows="3"
                                  :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                            </ValidationProvider>
                            <ValidationProvider name="Village Centric Comment (En)" vid="village_centric_comment" rules="required">
                                <b-form-group class="" label-for="village_centric_comment" slot-scope="{ valid, errors }">
                                  {{$t('social_service.coment_en')}}
                                  <b-form-textarea id="village_centric_comment" v-model="socio_ecio.village_centric_comment"
                                  rows="3"
                                  max-rows="3"
                                  :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                            </ValidationProvider>
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td class="w-25">
                            {{$t('social_service.city_center_life')}}
                          </b-td>
                          <b-td style="padding-left:20px">
                            <ValidationProvider name="City Centric" vid="city_centric" rules="required">
                                  <b-form-group v-slot="{ city_centric }">
                                    <b-form-radio v-model="socio_ecio.city_centric" :aria-describedby="city_centric" name="city_centric" value="1">{{$t('social_service.yes')}}</b-form-radio>
                                    <b-form-radio v-model="socio_ecio.city_centric" :aria-describedby="city_centric" name="city_centric" value="2">{{$t('social_service.no')}}</b-form-radio>
                                  </b-form-group>
                              </ValidationProvider>
                          </b-td>
                          <b-td style="padding-left:20px">
                            <ValidationProvider name="City Centric Comment (Bn)" vid="city_centric_comment_bn" rules="required">
                                <b-form-group class="" label-for="city_centric_comment_bn" slot-scope="{ valid, errors }">
                                  {{$t('social_service.coment_bn')}}
                                  <b-form-textarea id="city_centric_comment_bn" v-model="socio_ecio.city_centric_comment_bn"
                                  :class="{icons_long: !wrapIcons}"
                                  rows="3"
                                  max-rows="3"
                                  :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                            </ValidationProvider>
                            <ValidationProvider name="City Centric Comment (En)" vid="city_centric_comment" rules="required">
                                <b-form-group class="" label-for="city_centric_comment" slot-scope="{ valid, errors }">
                                  {{$t('social_service.coment_en')}}
                                  <b-form-textarea id="city_centric_comment" v-model="socio_ecio.city_centric_comment"
                                  rows="3"
                                  max-rows="3"
                                  :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                            </ValidationProvider>
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td class="w-25">
                            {{$t('social_service.prv_serv_from_hos')}}
                          </b-td>
                          <b-td style="padding-left:20px">
                            <ValidationProvider name="Previously Taken Service from This Hospital" vid="prev_hos" rules="required">
                                  <b-form-group v-slot="{ prev_hos }">
                                    <b-form-radio v-model="socio_ecio.prev_hos" :aria-describedby="prev_hos" name="prev_hos" value="1">{{$t('social_service.yes')}}</b-form-radio>
                                    <b-form-radio v-model="socio_ecio.prev_hos" :aria-describedby="prev_hos" name="prev_hos" value="2">{{$t('social_service.no')}}</b-form-radio>
                                  </b-form-group>
                              </ValidationProvider>
                          </b-td>
                          <b-td style="padding-left:20px">
                            <ValidationProvider name="Previously Taken Service from This Hospital Comment (Bn)" vid="prev_hos_comment_bn" rules="required">
                                <b-form-group class="" label-for="prev_hos_comment_bn" slot-scope="{ valid, errors }">
                                  {{$t('social_service.coment_bn')}}
                                  <b-form-textarea id="prev_hos_comment_bn" v-model="socio_ecio.prev_hos_comment_bn"
                                  :class="{icons_long: !wrapIcons}"
                                  rows="3"
                                  max-rows="3"
                                  :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                            </ValidationProvider>
                            <ValidationProvider name="Previously Taken Service from This Hospital Comment (En)" vid="prev_hos_comment" rules="required">
                                <b-form-group class="" label-for="prev_hos_comment" slot-scope="{ valid, errors }">
                                  {{$t('social_service.coment_en')}}
                                  <b-form-textarea id="prev_hos_comment" v-model="socio_ecio.prev_hos_comment"
                                  rows="3"
                                  max-rows="3"
                                  :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                            </ValidationProvider>
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td class="w-25">
                            {{$t('social_service.prv_serv_other_hos')}}
                          </b-td>
                          <b-td style="padding-left:20px">
                            <ValidationProvider name="Previously Taken Service from Other Hospital" vid="prev_other_hos" rules="required">
                                  <b-form-group v-slot="{ prev_other_hos }">
                                    <b-form-radio v-model="socio_ecio.prev_other_hos" :aria-describedby="prev_other_hos" name="prev_other_hos" value="1">{{$t('social_service.yes')}}</b-form-radio>
                                    <b-form-radio v-model="socio_ecio.prev_other_hos" :aria-describedby="prev_other_hos" name="prev_other_hos" value="2">{{$t('social_service.no')}}</b-form-radio>
                                  </b-form-group>
                              </ValidationProvider>
                          </b-td>
                          <b-td style="padding-left:20px">
                            <ValidationProvider name="Previously Taken Service from Other Hospital Comment (Bn)" vid="prev_other_hos_comment_bn" rules="required">
                                <b-form-group class="" label-for="prev_other_hos_comment_bn" slot-scope="{ valid, errors }">
                                  {{$t('social_service.coment_bn')}}
                                  <b-form-textarea id="prev_other_hos_comment_bn" v-model="socio_ecio.prev_other_hos_comment_bn"
                                  :class="{icons_long: !wrapIcons}"
                                  rows="3"
                                  max-rows="3"
                                  :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                            </ValidationProvider>
                            <ValidationProvider name="Previously Taken Service from Other Hospital Comment (En)" vid="prev_other_hos_comment" rules="required">
                                <b-form-group class="" label-for="prev_other_hos_comment" slot-scope="{ valid, errors }">
                                  {{$t('social_service.coment_en')}}
                                  <b-form-textarea id="prev_other_hos_comment" v-model="socio_ecio.prev_other_hos_comment"
                                  rows="3"
                                  max-rows="3"
                                  :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                            </ValidationProvider>
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td class="w-25">
                            {{$t('social_service.regu_serv_take_dss')}}
                          </b-td>
                          <b-td style="padding-left:20px">
                            <ValidationProvider name="Regular service taker from DSS" vid="reg_dss" rules="required">
                                  <b-form-group v-slot="{ reg_dss }">
                                    <b-form-radio v-model="socio_ecio.reg_dss" :aria-describedby="reg_dss" name="reg_dss" value="1">{{$t('social_service.yes')}}</b-form-radio>
                                    <b-form-radio v-model="socio_ecio.reg_dss" :aria-describedby="reg_dss" name="reg_dss" value="2">{{$t('social_service.no')}}</b-form-radio>
                                  </b-form-group>
                              </ValidationProvider>
                          </b-td>
                          <b-td style="padding-left:20px">
                            <ValidationProvider name="Regular service taker from DSS Comment (Bn)" vid="reg_dss_comment_bn" rules="required">
                                <b-form-group class="" label-for="reg_dss_comment_bn" slot-scope="{ valid, errors }">
                                  {{$t('social_service.coment_bn')}}
                                  <b-form-textarea id="reg_dss_comment_bn" v-model="socio_ecio.reg_dss_comment_bn"
                                  :class="{icons_long: !wrapIcons}"
                                  rows="3"
                                  max-rows="3"
                                  :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                            </ValidationProvider>
                            <ValidationProvider name="Regular service taker from DSS Comment (En)" vid="reg_dss_comment" rules="required">
                                <b-form-group class="" label-for="reg_dss_comment" slot-scope="{ valid, errors }">
                                  {{$t('social_service.coment_en')}}
                                  <b-form-textarea id="reg_dss_comment" v-model="socio_ecio.reg_dss_comment"
                                  rows="3"
                                  max-rows="3"
                                  :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                            </ValidationProvider>
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td class="w-25">
                            {{$t('social_service.pat_eli_fin_help')}}
                          </b-td>
                          <b-td style="padding-left:20px">
                            <ValidationProvider name="Patient Eligibility For Financial Help" vid="pat_eligibility" rules="required">
                                  <b-form-group v-slot="{ pat_eligibility }">
                                    <b-form-radio v-model="socio_ecio.pat_eligibility" :aria-describedby="pat_eligibility" name="pat_eligibility" value="1">{{$t('social_service.yes')}}</b-form-radio>
                                    <b-form-radio v-model="socio_ecio.pat_eligibility" :aria-describedby="pat_eligibility" name="pat_eligibility" value="2">{{$t('social_service.no')}}</b-form-radio>
                                  </b-form-group>
                              </ValidationProvider>
                          </b-td>
                          <b-td style="padding-left:20px">
                            <ValidationProvider name="Patient Eligibility For Financial Help Comment (En)" vid="pat_eligibility_comment_bn" rules="required">
                                <b-form-group class="" label-for="pat_eligibility_comment_bn" slot-scope="{ valid, errors }">
                                  {{$t('social_service.coment_bn')}}
                                  <b-form-textarea id="pat_eligibility_comment_bn" v-model="socio_ecio.pat_eligibility_comment_bn"
                                  :class="{icons_long: !wrapIcons}"
                                  rows="3"
                                  max-rows="3"
                                  :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                            </ValidationProvider>
                            <ValidationProvider name="Patient Eligibility For Financial Help Comment (En)" vid="pat_eligibility_comment" rules="required">
                                <b-form-group class="" label-for="pat_eligibility_comment" slot-scope="{ valid, errors }">
                                  {{$t('social_service.coment_en')}}
                                  <b-form-textarea id="pat_eligibility_comment" v-model="socio_ecio.pat_eligibility_comment"
                                  rows="3"
                                  max-rows="3"
                                  :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                            </ValidationProvider>
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td class="w-25">
                            {{$t('social_service.any_other_dept_help')}}
                          </b-td>
                          <b-td style="padding-left:20px">
                            <ValidationProvider name="Whether any other department benefits Help" vid="any_other_dept" rules="required">
                                  <b-form-group v-slot="{ any_other_dept }">
                                    <b-form-radio v-model="socio_ecio.any_other_dept" :aria-describedby="any_other_dept" name="any_other_dept" value="1">{{$t('social_service.yes')}}</b-form-radio>
                                    <b-form-radio v-model="socio_ecio.any_other_dept" :aria-describedby="any_other_dept" name="any_other_dept" value="2">{{$t('social_service.no')}}</b-form-radio>
                                  </b-form-group>
                              </ValidationProvider>
                          </b-td>
                          <b-td style="padding-left:20px">
                            <ValidationProvider name="Whether any other department benefits Help Comment (En)" vid="any_other_dept_comment_bn" rules="required">
                                <b-form-group class="" label-for="any_other_dept_comment_bn" slot-scope="{ valid, errors }">
                                  {{$t('social_service.coment_bn')}}
                                  <b-form-textarea id="any_other_dept_comment_bn" v-model="socio_ecio.any_other_dept_comment_bn"
                                  :class="{icons_long: !wrapIcons}"
                                  rows="3"
                                  max-rows="3"
                                  :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                            </ValidationProvider>
                            <ValidationProvider name="Whether any other department benefits Help Comment (En)" vid="any_other_dept_comment" rules="required">
                                <b-form-group class="" label-for="any_other_dept_comment" slot-scope="{ valid, errors }">
                                  {{$t('social_service.coment_en')}}
                                  <b-form-textarea id="any_other_dept_comment" v-model="socio_ecio.any_other_dept_comment"
                                  rows="3"
                                  max-rows="3"
                                  :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                            </ValidationProvider>
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td class="w-25">
                            {{$t('social_service.reffered_to_another_help')}}
                          </b-td>
                          <b-td style="padding-left:20px">
                            <ValidationProvider name="Whether the patient can be referred to another hospital or not" vid="reffered_to_another" rules="required">
                                  <b-form-group v-slot="{ reffered_to_another }">
                                    <b-form-radio v-model="socio_ecio.reffered_to_another" :aria-describedby="reffered_to_another" name="reffered_to_another" value="1">{{$t('social_service.yes')}}</b-form-radio>
                                    <b-form-radio v-model="socio_ecio.reffered_to_another" :aria-describedby="reffered_to_another" name="reffered_to_another" value="2">{{$t('social_service.no')}}</b-form-radio>
                                  </b-form-group>
                              </ValidationProvider>
                          </b-td>
                          <b-td style="padding-left:20px">
                            <ValidationProvider name="Whether the patient can be referred to another hospital or not Comment (En)" vid="reffered_to_another_comment_bn" rules="required">
                                <b-form-group class="" label-for="reffered_to_another_comment_bn" slot-scope="{ valid, errors }">
                                  {{$t('social_service.coment_bn')}}
                                  <b-form-textarea id="reffered_to_another_comment_bn" v-model="socio_ecio.reffered_to_another_comment_bn"
                                  :class="{icons_long: !wrapIcons}"
                                  rows="3"
                                  max-rows="3"
                                  :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                            </ValidationProvider>
                            <ValidationProvider name="Whether the patient can be referred to another hospital or not Comment (En)" vid="reffered_to_another_comment" rules="required">
                                <b-form-group class="" label-for="reffered_to_another_comment" slot-scope="{ valid, errors }">
                                  {{$t('social_service.coment_en')}}
                                  <b-form-textarea id="reffered_to_another_comment" v-model="socio_ecio.reffered_to_another_comment"
                                  rows="3"
                                  max-rows="3"
                                  :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                            </ValidationProvider>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </template>
                </iq-card>
                <iq-card>
                  <template v-slot:body>
                    <b-row style="border: 1px solid rgba(0, 0, 0, 0.125);padding:10px">
                      <b-col md="4">
                        <ValidationProvider name="Pusti Mapping Id" vid="social_service_id">
                          <b-form-group class="row" label-cols-sm="6" label-for="social_service_id" slot-scope="{ valid, errors }">
                            <template v-slot:label>
                              {{$t('social_service.medi_assis_ofc')}}
                            </template>
                            <!-- <b-form-input
                            type="text"
                            id="pay_grade"
                            v-model="socio_ecio.patient_en"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input> -->
                            <b-form-select
                              plain
                              v-model="med_assistance.assistance_type_id"
                              :options="medicalAssistanceList"
                              id="assistance_type_id"
                              :state="errors[0] ? false : (valid ? true : null)"
                              >
                              <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                              </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                      <b-col md="4">
                        <ValidationProvider name="Rehab Description (Bn)" vid="rehab_description_bn">
                          <b-form-group class="row" label-cols-sm="6" label-for="rehab_description_bn" slot-scope="{ valid, errors }">
                            <template v-slot:label>
                              {{$t('social_service.rehabil_desc_par_bn')}}
                            </template>
                            <b-form-input
                            type="text"
                            id="rehab_description_bn"
                            v-model="med_assistance.rehab_description_bn"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                      <b-col md="4">
                        <ValidationProvider name="Rehab Description" vid="rehab_description">
                          <b-form-group class="row" label-cols-sm="6" label-for="rehab_description" slot-scope="{ valid, errors }">
                            <template v-slot:label>
                              {{$t('social_service.rehabil_desc_par_en')}}
                            </template>
                            <b-form-input
                            type="text"
                            id="pay_grade"
                            v-model="med_assistance.rehab_description"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                      <b-col md="4">
                        <ValidationProvider name="Receiver Name (Bn)" vid="receiver_name_bn" rules="required">
                          <b-form-group class="row" label-cols-sm="6" label-for="receiver_name_bn" slot-scope="{ valid, errors }">
                            <template v-slot:label>
                              {{$t('social_service.cash_recv_bn')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-input
                            type="text"
                            id="receiver_name_bn"
                            v-model="med_assistance.receiver_name_bn"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                      <b-col md="4">
                        <ValidationProvider name="Receiver Name (En)" vid="receiver_name" rules="required">
                          <b-form-group class="row" label-cols-sm="6" label-for="receiver_name" slot-scope="{ valid, errors }">
                            <template v-slot:label>
                              {{$t('social_service.cash_recv_en')}}
                            </template>
                            <b-form-input
                            id="receiver_name"
                            v-model="med_assistance.receiver_name"
                            :state="errors[0] ? false : (valid ? true : null)"
                            >
                            </b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                      <b-col md="4">
                        <ValidationProvider name="Designation (Bn)" vid="designation_bn" rules="required">
                          <b-form-group class="row" label-cols-sm="6" label-for="designation_bn" slot-scope="{ valid, errors }">
                            <template v-slot:label>
                              {{ $t('social_service.case_rec_des_bn') }} <span class="text-danger">*</span>
                            </template>
                            <b-form-input
                            type="text"
                            id="designation_bn"
                            v-model="med_assistance.designation_bn"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                      <b-col md="4">
                        <ValidationProvider name="Designation (En)" vid="designation" rules="required">
                          <b-form-group class="row" label-cols-sm="6" label-for="designation" slot-scope="{ valid, errors }">
                            <template v-slot:label>
                              {{$t('social_service.case_rec_des_en')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-input
                            type="text"
                            id="designation"
                            v-model="med_assistance.designation"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                      <b-col md="4">
                        <ValidationProvider name="Officer Name (Bn)" vid="officer_name_bn" rules="required">
                          <b-form-group class="row" label-cols-sm="6" label-for="officer_name_bn" slot-scope="{ valid, errors }">
                            <template v-slot:label>
                              {{$t('social_service.related_officer_name_bn')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-input
                            type="text"
                            id="officer_name_bn"
                            v-model="med_assistance.officer_name_bn"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                      <b-col md="4">
                        <ValidationProvider name="Officer Name (En)" vid="officer_name" rules="required">
                          <b-form-group class="row" label-cols-sm="6" label-for="officer_name" slot-scope="{ valid, errors }">
                            <template v-slot:label>
                              {{$t('social_service.related_officer_name_en')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-input
                            type="text"
                            id="officer_name"
                            v-model="med_assistance.officer_name"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                      <b-col md="6">
                        <ValidationProvider name="Comments (Bn)" vid="comments_bn" rules="">
                          <b-form-group class="row" label-cols-sm="6" label-for="comments_bn" slot-scope="{ valid, errors }">
                            <template v-slot:label>
                              {{$t('social_service.related_officer_comment_bn')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-textarea
                                id="comments_bn"
                                v-model="med_assistance.comments_bn"
                                rows="1"
                                max-rows="2"
                                :state="errors[0] ? false : (valid ? true : null)"
                              ></b-form-textarea>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                      <b-col md="6">
                        <ValidationProvider name="Comments (En)" vid="comments" rules="">
                          <b-form-group class="row" label-cols-sm="6" label-for="comments" slot-scope="{ valid, errors }">
                            <template v-slot:label>
                              {{$t('social_service.related_officer_comment_en')}}
                            </template>
                            <b-form-textarea
                                id="comments"
                                v-model="med_assistance.comments"
                                rows="1"
                                max-rows="2"
                                :state="errors[0] ? false : (valid ? true : null)"
                              ></b-form-textarea>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                    </b-row>
                  </template>
                </iq-card>
              </b-card>
            </b-form>
        </ValidationObserver>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
import { caseHistoryStoreApi } from '../../../api/routes'
import ExportPdf from './export-pdf_details'
import StaticData from './static_data.js'

export default {
  name: 'FormLayout',
  data () {
    return {
      wrapIcons: false,
      rows: []
    }
  },
  mounted () {
    core.index()
  },
  props: ['info_id', 'patient_form', 'admisson_other_info', 'address_family_info', 'socio_ecio', 'med_assistance'],
  computed: {
    medicalAssistanceList: function () {
          return StaticData.medicalAssistanceList(this)
          // let tmpData = {}
          // tmpData = eduList.find(eduItem => eduItem.value === this.social_info.father_education_status)
          // const eduData = { label: tmpData.label }
          // return eduData
    }
  },
  methods: {
    async submit () {
      this.med_assistance.case_main_id = parseInt(this.$route.params.case_id) > 0 ? parseInt(this.$route.params.case_id) : 0
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      let result = null
      const loadingState = { loading: false, listReload: false }
      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }
      // this.patient_registration.patient_acknowledgement = JSON.stringify(this.patient_registration.patient_acknowledgement)
      var formData = new FormData()
      formData.append('patient_form', JSON.stringify(this.patient_form))
      formData.append('address_family_info', JSON.stringify(this.address_family_info))
      formData.append('admisson_other_info', JSON.stringify(this.admisson_other_info))
      formData.append('socio_ecio', JSON.stringify(this.socio_ecio))
      formData.append('med_assistance', JSON.stringify(this.med_assistance))
      formData.append('case_main_id', parseInt(this.$route.params.case_id) > 0 ? parseInt(this.$route.params.case_id) : 0)
      formData.append('_method', 'POST')
      result = await RestApi.postData(hospitalServiceBaseUrl, caseHistoryStoreApi, formData, config)

      loadingState.listReload = true
      this.$store.dispatch('mutateCommonProperties', loadingState)
      if (result.success) {
        this.$store.commit('HospitalDisabilityService/mutateCommonObj', { hasDropdownLoaded: false })
          this.$toast.success({
            title: 'Success',
            message: this.$t('globalTrans.save_msg'),
            color: '#D6E09B'
          })
          return result
          } else {
            this.$toast.error({
                title: 'Error',
                message: this.$t('globalTrans.form_error_msg'),
                color: '#D6E09B'
            })
            this.$refs.form.setErrors(result.errors)
          }
    },
    pdfExport () {
      this.printInfoData.form_id = this.social_info.social_service_id
      this.printInfoData.form_date = this.social_info.social_service_date
      this.printSData.name_en = this.social_info.name_en
      this.printSData.name_bn = this.social_info.name_bn
      this.printSData.father_name_en = this.social_info.father_name_en
      this.printSData.father_name_bn = this.social_info.father_name_bn
      this.printSData.mother_name_en = this.social_info.mother_name_en
      this.printSData.mother_name_bn = this.social_info.mother_name_bn
      this.printSData.age = this.social_info.age
      this.printSData.gender = this.gender.label
      this.printSData.father_education_status = this.father_education_status.label
      this.printSData.mother_education_status = this.mother_education_status.label
      this.printSData.earning_member = this.earning_member.label
      this.printSData.monthly_family_income = this.monthly_family_income.label
      this.printSData.income_source = this.income_source.label
      this.printSData.family_category = this.family_category.label
      this.printSData.no_of_family_member = this.social_info.no_of_family_member
      this.printSData.religion = this.religion.label
      this.printSData.area_type_id = this.areatype.label
      this.printSData.division_id = this.division.label
      this.printSData.district_id = this.district.label
      if (this.social_info.pauroshoba_id) {
        this.printSData.pauroshoba_id = this.pauroshoba.label
      }
      this.printSData.ward_id = this.ward.label
      if (this.social_info.city_corporation_id) {
        this.printSData.city_corporation_id = this.city_corporation.label
      }
      if (this.social_info.upazila_id) {
        this.printSData.upazila_id = this.upazila.label
      }
      if (this.social_info.union_id) {
        this.printSData.union_id = this.union.label
      }
      this.printSData.village_en = this.social_info.village_en
      this.printSData.village_bn = this.social_info.village_bn
      this.printSData.mobile_no = this.social_info.mobile_no
      this.printPData.height = this.physical_info.height
      this.printPData.weight = this.physical_info.weight
      this.printPData.head_circumference = this.physical_info.head_circumference
      this.printPData.chest_circumference = this.physical_info.head_circumference
      this.printPData.muac = this.muac.label
      this.printHData.question_no_1 = this.question_no_1.label
      this.printHData.question_no_2 = this.question_no_2.label
      this.printHData.question_no_3 = this.socio_ecio.question_no_3
      this.printHData.question_no_4 = this.question_no_4.label
      this.printHData.question_no_5 = this.question_no_5.label
      this.printHData.question_no_6 = this.question_no_6.label
      this.printHData.question_no_7 = this.question_no_7.label
      this.printHData.question_no_8 = this.question_no_8.label
      this.printHData.question_no_9 = this.question_no_9.label
      this.printHData.question_no_10 = this.question_no_10.label
      this.printHData.question_no_11 = this.question_no_11.label
      this.printHData.question_no_12 = this.question_no_12.label
      this.printHData.question_no_13 = this.question_no_13.label
      this.printHData.question_no_14 = this.question_no_14.label
      this.printHData.question_no_15 = this.question_no_15.label
      this.printHData.question_no_16 = this.question_no_16.label
      this.printHData.question_no_17 = this.question_no_17.label
      this.printHData.question_no_18 = this.question_no_18.label

      const reportTitle = this.$t('social_service.socio_ecio')
      ExportPdf.exportPdfDetails(hospitalServiceBaseUrl, '/cotton/config/report-heading/detail', 3, reportTitle, this.printInfoData, this, this.printSData, this.printPData, this.printHData)
    }
  }
}
</script>
